function BlankPage() {
  return (
    null
  );
}


export default BlankPage;